import { TrackEventName as EventName, TrackEvent as Event } from '../event';

const observeSliderEvent = () => {
  // bz侧边栏按钮点击事件上报
  Event.safeOn(EventName.BZ_SIDEBAR_BUTTON_CLICK, (data = {}) => {
    const val = {
      ...data,
      event: EventName.BZ_SIDEBAR_BUTTON_CLICK,
    };
    Event.emit(EventName.SENSORS_TRACK, val);
  });
};

export default observeSliderEvent;
